import useTheme from 'chat-ui/src/hooks/useTheme';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from 'src/components/Navbar/Navbar';
import Sidebar from 'src/components/Sidebar/Sidebar';
import useSidebarStore from '@/store/SidebarStore';
import { cn } from '@/lib/utils';
import { isProjectPage as isProjectPageUtil } from '@/utils/isProjectPage';

function AuthContent() {
  const location = useLocation();
  const isProjectPage = isProjectPageUtil(location.pathname);
  const hideSidebar = useSidebarStore((state) => state.hideSidebar);
  const { currentTheme } = useTheme();

  return (
    <div className="flex w-full">
      {!isProjectPage && <Sidebar />}
      <main
        style={{ backgroundColor: currentTheme?.background, color: currentTheme?.['primary-text'] }}
        className="relative w-full h-full min-h-screen p-[2%] pt-0 overflow-hidden text-dark-text"
      >
        <div
          className={`flex flex-col w-full h-full min450:pl-0 
        ${isProjectPage && '!pl-0'}
        ${!hideSidebar && !isProjectPage ? 'pl-[270px]' : 'pl-20'}`}
        >
          <Navbar />
          <div className={cn(isProjectPage ? 'pt-16' : 'pt-20')}>
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  );
}

export default AuthContent;
